<jrui-search-bar
  [searchTerms]="searchTerms"
  [placeholderText]="placeholderText"
  (inputText)="onInput($event)"
  (searchText)="onSearch()"
></jrui-search-bar>
